import { TableBadgeLabel } from '@components'

import React, { ReactElement, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountStatement } from '../../hooks/useAccountStatement'

export const AccountTableTitle = (): ReactElement => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(true)
  const { accountStatement, isLoading: isAccountStatementLoading } = useAccountStatement()

  useEffect(() => {
    if (!isAccountStatementLoading && isLoading) {
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only want to run when isAccountStatementLoading changes
  }, [isAccountStatementLoading])

  return (
    <TableBadgeLabel amount={accountStatement?.rows.length} isLoading={isLoading} color="neutral">
      {t('postings')}
    </TableBadgeLabel>
  )
}
